
import React from 'react';
import { Link } from 'react-router-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

const classNames = mergeStyleSets({
    linkDisabled: {
        color: '#aaaaaa'
    },
    link: {
        'a': {
            color: '#7f5326',
            textDecoration: 'none'
        },
        'a:hover': {
            color: '#7f5326',
            textDecoration: 'underline'
        },
        'a:visited': {
            color: '#7f5326'
        }
    }
});

const AuthLink = ({disabled, page, title}) => {
    return (
        <Stack horizontal horizontalAlign="end">
            <Text className={disabled ? classNames.linkDisabled : classNames.link}>
                {!disabled
                    ? <Link to={`/${page}`}>{title}</Link>
                    : <span>{title}</span>
                }
            </Text>
        </Stack>
    );
}

export default AuthLink;
